import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white text-gray-800">
      {/* Header */}
      <div data-on-dark="true" className="bg-[#6C63FF] text-white py-12 px-6">
        <div className="max-w-3xl mx-auto">
          <Link to="/" className="text-white hover:text-white text-sm mb-4 inline-block opacity-90 hover:opacity-100">← Torna a Yollo</Link>
          <h1 className="text-3xl font-bold text-white">Privacy Policy</h1>
          <p className="text-white mt-2 text-sm">Ultimo aggiornamento: maggio 2026 — conforme al Regolamento UE 2016/679 (GDPR)</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-12 space-y-10 text-[15px] leading-relaxed">

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">1. Titolare del Trattamento</h2>
          <p>Il Titolare del trattamento dei dati personali raccolti tramite il sito <strong>yollo.me</strong> è:</p>
          <div className="mt-3 p-4 bg-gray-50 rounded-xl border border-gray-200 text-sm">
            <p><strong>Luchapp S.r.l.</strong></p>
            <p>Via Tucci 4 — 04100 Latina (LT)</p>
            <p>P.IVA: 03368240598</p>
            <p>Email: <a href="mailto:luchappsrls@legalmail.it" className="text-[#6C63FF]">luchappsrls@legalmail.it</a></p>
            <p>Sito web: <a href="https://yollo.me" className="text-[#6C63FF]">yollo.me</a></p>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">2. Tipologie di Dati Trattati</h2>

          <h3 className="font-semibold text-gray-800 mt-4 mb-2">2.1 Dati di navigazione</h3>
          <p>I sistemi informatici e le procedure software preposte al funzionamento di questo sito acquisiscono, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell'uso dei protocolli di comunicazione di Internet (es. indirizzi IP, tipo di browser, sistema operativo, URI delle risorse richieste e ora della richiesta).</p>

          <h3 className="font-semibold text-gray-800 mt-4 mb-2">2.2 Dati forniti volontariamente dall'utente</h3>
          <p>In fase di registrazione al servizio Yollo vengono raccolti:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
            <li>Nome e cognome del referente aziendale</li>
            <li>Indirizzo email (usato come credenziale di accesso)</li>
            <li>Numero di telefono</li>
            <li>Ragione sociale e Partita IVA dell'azienda</li>
            <li>Dati di pagamento (gestiti direttamente da Stripe — non conservati da Yollo)</li>
          </ul>

          <h3 className="font-semibold text-gray-800 mt-4 mb-2">2.3 Dati degli operatori</h3>
          <p>Gli amministratori possono inserire dati dei propri dipendenti/collaboratori (nome, contatto, dati contrattuali). In questo caso l'amministratore agisce come responsabile autonomo del trattamento dei dati dei propri dipendenti.</p>

          <h3 className="font-semibold text-gray-800 mt-4 mb-2">2.4 Dati di utilizzo</h3>
          <p>Vengono raccolti dati aggregati e anonimi sull'utilizzo della piattaforma (pagine visitate, funzionalità usate) tramite Google Analytics 4. Per dettagli vedere la <Link to="/cookie-policy" className="text-[#6C63FF] underline">Cookie Policy</Link>.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">3. Finalità e Basi Giuridiche del Trattamento</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm border-collapse mt-2">
              <thead>
                <tr className="bg-gray-50">
                  <th className="text-left p-3 border border-gray-200 font-semibold">Finalità</th>
                  <th className="text-left p-3 border border-gray-200 font-semibold">Base giuridica (art. 6 GDPR)</th>
                </tr>
              </thead>
              <tbody>
                {[
                  ["Erogazione del servizio Yollo (account, login, dashboard)", "Esecuzione del contratto — art. 6(1)(b)"],
                  ["Gestione pagamenti e abbonamenti tramite Stripe", "Esecuzione del contratto — art. 6(1)(b)"],
                  ["Invio email transazionali (accesso, conferme, notifiche)", "Esecuzione del contratto — art. 6(1)(b)"],
                  ["Assistenza e supporto all'utente", "Legittimo interesse — art. 6(1)(f)"],
                  ["Analisi statistica anonima del traffico (GA4)", "Consenso — art. 6(1)(a)"],
                  ["Adempimento obblighi legali e fiscali", "Obbligo legale — art. 6(1)(c)"],
                  ["Sicurezza, prevenzione frodi e abusi", "Legittimo interesse — art. 6(1)(f)"],
                ].map(([fin, base], i) => (
                  <tr key={i} className={i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}>
                    <td className="p-3 border border-gray-200">{fin}</td>
                    <td className="p-3 border border-gray-200 text-gray-600">{base}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">4. Conservazione dei Dati</h2>
          <p>I dati personali sono conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
            <li><strong>Dati di account attivo:</strong> per tutta la durata del rapporto contrattuale</li>
            <li><strong>Dati dopo cancellazione account:</strong> fino a 12 mesi per obblighi legali/fiscali</li>
            <li><strong>Log di accesso e sicurezza:</strong> 6 mesi</li>
            <li><strong>Dati analitici GA4:</strong> 14 mesi (impostazione predefinita Google)</li>
            <li><strong>Comunicazioni email:</strong> 24 mesi</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">5. Destinatari e Responsabili del Trattamento</h2>
          <p>I dati personali possono essere comunicati a soggetti terzi che operano come Responsabili del Trattamento ai sensi dell'art. 28 GDPR:</p>
          <div className="mt-3 space-y-3">
            {[
              { nome: "Stripe Inc.", ruolo: "Elaborazione pagamenti", paese: "USA (adequacy + SCCs)", link: "https://stripe.com/privacy" },
              { nome: "Google LLC (Google Analytics 4)", ruolo: "Analisi traffico web (anonimizzato)", paese: "USA (adequacy + SCCs)", link: "https://policies.google.com/privacy" },
              { nome: "Resend Inc.", ruolo: "Invio email transazionali", paese: "USA (SCCs)", link: "https://resend.com/privacy" },
              { nome: "Telegram FZ-LLC", ruolo: "Notifiche bot (se attivato dall'utente)", paese: "Dubai/UAE", link: "https://telegram.org/privacy" },
              { nome: "Emergent (provider hosting)", ruolo: "Infrastruttura cloud e storage", paese: "UE", link: null },
            ].map((s, i) => (
              <div key={i} className="p-3 bg-gray-50 rounded-lg border border-gray-200 text-sm">
                <span className="font-semibold">{s.nome}</span> — {s.ruolo}
                <span className="text-gray-500 ml-2">({s.paese})</span>
                {s.link && <a href={s.link} target="_blank" rel="noreferrer" className="ml-2 text-[#6C63FF] underline">Privacy Policy</a>}
              </div>
            ))}
          </div>
          <p className="mt-3 text-sm text-gray-600">I dati non vengono venduti a terzi né ceduti per finalità di marketing senza esplicito consenso.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">6. Trasferimento Dati Extra-UE</h2>
          <p>Alcuni fornitori (Stripe, Google, Resend) sono basati negli Stati Uniti. I trasferimenti avvengono nel rispetto delle garanzie previste dal GDPR: clausole contrattuali standard (SCC) approvate dalla Commissione Europea e/o decisioni di adeguatezza.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">7. Diritti dell'Interessato</h2>
          <p>Ai sensi degli artt. 15–22 del GDPR, l'utente ha il diritto di:</p>
          <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
            <li><strong>Accesso</strong> — ottenere conferma del trattamento e copia dei dati (art. 15)</li>
            <li><strong>Rettifica</strong> — correggere dati inesatti o incompleti (art. 16)</li>
            <li><strong>Cancellazione</strong> — richiedere la rimozione dei dati ("diritto all'oblio") (art. 17)</li>
            <li><strong>Limitazione</strong> — limitare il trattamento in determinate circostanze (art. 18)</li>
            <li><strong>Portabilità</strong> — ricevere i propri dati in formato strutturato (art. 20)</li>
            <li><strong>Opposizione</strong> — opporsi al trattamento basato su legittimo interesse (art. 21)</li>
            <li><strong>Revoca del consenso</strong> — revocare in qualsiasi momento il consenso prestato (art. 7(3))</li>
          </ul>
          <p className="mt-3">Per esercitare i propri diritti, scrivere a: <a href="mailto:luchappsrls@legalmail.it" className="text-[#6C63FF] underline">luchappsrls@legalmail.it</a></p>
          <p className="mt-2">In caso di risposta insoddisfacente, è possibile proporre reclamo al <strong>Garante per la Protezione dei Dati Personali</strong> (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer" className="text-[#6C63FF] underline">garanteprivacy.it</a>).</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">8. Cookie</h2>
          <p>Questo sito utilizza cookie tecnici e, previo consenso, cookie analitici. Per informazioni dettagliate consulta la nostra <Link to="/cookie-policy" className="text-[#6C63FF] underline">Cookie Policy</Link>.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">9. Sicurezza dei Dati</h2>
          <p>Adottiamo misure tecniche e organizzative adeguate per proteggere i dati personali da accesso non autorizzato, perdita, distruzione o divulgazione, incluse: crittografia in transito (HTTPS/TLS), autenticazione sicura con token JWT, controllo degli accessi per ruolo, backup automatici giornalieri e isolamento completo tra tenant diversi.</p>
        </section>

        <section>
          <h2 className="text-xl font-bold text-gray-900 mb-3">10. Modifiche alla Privacy Policy</h2>
          <p>Luchapp S.r.l. si riserva il diritto di aggiornare questa Privacy Policy. In caso di modifiche sostanziali, gli utenti registrati saranno informati via email. La versione aggiornata sarà sempre disponibile su questa pagina con data di revisione indicata.</p>
        </section>

        <div className="border-t border-gray-200 pt-8 text-sm text-gray-500 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <span>© 2026 Luchapp S.r.l. — Tutti i diritti riservati</span>
          <div className="flex gap-4">
            <Link to="/cookie-policy" className="text-[#6C63FF] hover:underline">Cookie Policy</Link>
            <Link to="/" className="hover:underline">Torna a Yollo</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
